import React from "react";
import { NavItem, NavLink, Nav } from "reactstrap";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { House, CardChecklist, Clipboard } from 'react-bootstrap-icons';
import "./sidebar.scss";

const SideBar = ({ isOpen }) => (
  <div className={classNames("sidebar", { hidden: isOpen })}>
    <div>
      <Nav vertical className="list-unstyled pb-3">
        <NavItem>
          <NavLink tag={Link} to={"/home"}>
            <House className="icon" /> Home
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} to={"/visits"}>
            <CardChecklist className="icon" /> Visits
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag={Link} to={"/report"}>
            <Clipboard className="icon" /> Report
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  </div>
);

export default SideBar;
